import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ e("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), l = /* @__PURE__ */ e("path", {
  fill: "#338AF3",
  d: "M20 14.783h19.311a19.888 19.888 0 0 0-2.246-5.218H20v5.218ZM7.55 35.652h24.9a20.1 20.1 0 0 0 4.614-5.217H2.935a20.104 20.104 0 0 0 4.615 5.217ZM6.956 4.84a20.098 20.098 0 0 0-4.02 4.725h4.02V4.84ZM20 20v-5.217h-7.826V20H6.956v-5.217H.69A20.022 20.022 0 0 0 0 20c0 1.805.24 3.554.689 5.218H39.31c.449-1.665.69-3.413.69-5.218H20Zm0-20a19.94 19.94 0 0 0-7.826 1.59v7.975H20V4.348h12.45A19.914 19.914 0 0 0 20 0Z"
}, null, -1), s = [
  c,
  l
];
function h(r, a) {
  return t(), o("svg", n, [...s]);
}
const i = { render: h };
export {
  i as default,
  h as render
};
